import * as React from 'react';
import {PREDICTION_HISTOGRAM_DRAW_BAR,
        PREDICTION_HISTOGRAM_DRAW_PAINT,
         HISTOGRAM_CHART, SCATTERPLOT_CHART} from './Constants'
import HistogramToolBar from '../Charts/Histogram/HistogramToolBar'
import {useState} from 'react';
import { Icon } from 'semantic-ui-react'
import { Menu } from 'semantic-ui-react'
import {extent as d3ArrayExtent, histogram} from 'd3-array'
import {axisBottom as d3AxisBottom,
        axisLeft as d3AxisLeft, } from 'd3-axis'
import {min as d3min,
        max as d3max} from 'd3'
import {scaleLinear as d3ScaleLinear,
        scalePoint as d3ScalePoint} from 'd3-scale'
import { select as d3Select, selectAll as d3SelectAll} from 'd3-selection'
import {line as d3Line } from 'd3-shape'
import '../../../css/ScatterPlot.css';
import * as aggregation from '../aggregation/countAggregation'
import { func } from 'prop-types';
import '../../../css/external/font-awesome.css'
import { GraphPredictContext } from './GraphPredictContext';
import PredictionToolDraw from './PredictionToolDraw';

interface PredictionToolBoxProps
{
   id:string,
   masterid:string,
  
   
}

const PredictionToolBox: React.FC<PredictionToolBoxProps> = ({id,masterid}) => {

        var toolbox:any  =''
        var tooldraw:any  =''
        const [value, set] = useState(true);
        const {setgrapVisOptions, grapVisOptions} = GraphPredictContext()
        
       
        var graphType = grapVisOptions['graphType']
        var graphDraw = grapVisOptions['graphDraw']
        console.log('PredictionToolBox grapVisOptions',grapVisOptions)
        
        const toolbarStyle = {
                'height': '40px',
                'width':'380px',
                'top': 40+'px', 
            } 

        if(graphType == HISTOGRAM_CHART)
        {
                
                console.log('PredictionToolBox graphType',graphType)
                toolbox = <HistogramToolBar id={id} masterid={masterid} style={toolbarStyle}></HistogramToolBar>

        }
        else
        {
                toolbox =''
        }
        
        return(
            <>
            {toolbox}
        
            </>
        );
}
export default PredictionToolBox;
